export type OrderStatus =
  | 'PLACED'
  | 'ACCEPTED'
  | 'OUT_FOR_DELIVERY'
  | 'READY'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'REJECTED';

export const ORDER_STATUS_OPTIONS: OrderStatus[] = [
  'PLACED',
  'ACCEPTED',
  'OUT_FOR_DELIVERY',
  'READY',
  'COMPLETED',
  'CANCELLED',
  'REJECTED',
];

export type AdminOrderItem = {
  id: string;
  name: string;
  unit_price_inr: string;
  quantity: number;
  line_total_inr: string;
};

export type AdminOrder = {
  id: string;
  status: OrderStatus;
  fulfillment_type: 'DELIVERY' | 'PICKUP';
  total_inr: string;
  vendor_business_name: string | null;
  customer_name: string | null;
  contact_phone: string;
  created_at: string;
  items: AdminOrderItem[];
};

export type AdminOrderListResponse = {
  items: AdminOrder[];
  total: number;
  page: number;
  page_size: number;
};

export type AdminOrderFilters = {
  page?: number;
  page_size?: number;
  status?: OrderStatus;
  /** Inclusive created-date range, YYYY-MM-DD. */
  from?: string;
  to?: string;
  /** Narrow to one vendor. */
  vendor_profile_id?: string;
};
